export enum ParticipatingType {
  myTeam = 'my team',
  benefitingCharity = 'benefiting charity',
  teamCamptain = "team's captain",
}
